import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';
import { isYes } from '../../../../../../../components/loan_application/utils/helpers';

const { systemPropertyOwnerRelatedToBorrower } = loanFormModel.formField;

class IsSystemPropertyOwnerRelatedToBorrower implements Rule {
  private getLandLord(data: Partial<ApplicationFormValues>) {
    return data.principals?.find(
      (principal) =>
        principal.relationship === RELATED_PARTY_RELATIONSHIP.LANDLORD
    );
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const landLord = this.getLandLord(application);

    const isSystemPropertyOwnerRelatedToBorrowerValue =
      landLord?.[systemPropertyOwnerRelatedToBorrower.name];

    return isYes(isSystemPropertyOwnerRelatedToBorrowerValue);
  }
}

export default new IsSystemPropertyOwnerRelatedToBorrower();
